import LiftRAndRLogo from '@/assets/branding/liftrandr/lift-r-and-r-logo.png';

export default {
  name: 'Lift R & R',
  isSAML: true,
  allowPersonalCourses: false,
  logo: LiftRAndRLogo,
  colors: {
    // Brand colors
    brand_primary: '#EB6D29', // H21°, L54, S83
    brand_primary_hover: '#C4571C', // −10 L, −8 S
    brand_primary_highlight: '#F9B590', // +23 L, +7 S
    brand_primary_mid: '#F0854C', // +8 L,  +2 S
    brand_primary_dark: '#85380F', // −25 L, −3 S
    brand_secondary: '#A9581E', // hue +4°, −15 L, −13 S
  },
};
